/**
 * External Dependencies
 */
import "jquery";

import "@fancyapps/fancybox/dist/jquery.fancybox.js";
import "jquery-validation/dist/jquery.validate";

import lazySizes from "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
lazySizes.cfg.lazyClass = "lazy";
// lazySizes.cfg.expand = -10;
lazySizes.cfg.loadMode = 1;
import { ready } from "./helpers";
// import smoothscroll from "smoothscroll-polyfill";

import { Swiper, Pagination, Autoplay } from "swiper";
Swiper.use([Pagination, Autoplay]);

import { gsap, Expo } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.defaults({
  toggleActions: "play pause resume reset"
});

import "./forms";
import "./font-awesome";
import "./map";

ready(() => {
  /**
   * Handle hamburger
   */
  const ham = document.querySelector("header .hamburger");
  const menu = document.querySelector("header nav .menu");
  ham.addEventListener("click", () => {
    ham.classList.toggle("active");
    menu.classList.toggle("active");
  });

  /**
   * Accordion
   */
  const accordionItems = Array.from(
    document.getElementsByClassName("accordion__item")
  );
  if (accordionItems) {
    accordionItems.map((i) => {
      i.addEventListener("click", () => {
        i.classList.remove("expanded-initially"); // remove the initial class as the height auto needs to be applied by gsap for future transitions
        var accContent = i.querySelector(".accordion__item__content");
        if (i.classList.contains("expanded")) {
          wrFadeUpOut(accContent);
        } else {
          wrFadeDownIn(accContent);
        }
        i.classList.toggle("expanded");
      });
    });
  }

  /**
   * Gsap
   */
  const wrFadeUpOut = (elem) => {
    gsap.to(elem, {
      y: -100,
      autoAlpha: 0,
      ease: Expo.easeInOut,
      height: "0"
    });
    elem.classList.remove("active");
  };
  const wrFadeDownIn = (elem) => {
    gsap.to(elem, {
      y: 0,
      autoAlpha: 1,
      ease: Expo.easeInOut,
      height: "auto"
    });
    elem.classList.add("active");
  };

  /**
   * Handle dropdown menus
   */
  const dropdownMenus = document.querySelectorAll(".dropdown");
  if (dropdownMenus) {
    dropdownMenus.forEach((i) => {
      let dropdownToggle = i.children[0];
      let dropdownMenu = i.children[1];
      let applyIn = [dropdownToggle, dropdownMenu];
      let applyOut = [dropdownToggle, dropdownMenu];
      applyIn.forEach((i) => {
        i.addEventListener("mouseenter", () => {
          wrFadeDownIn(dropdownMenu);
          dropdownToggle.classList.add("active");
        });
      });
      applyOut.forEach((i) => {
        i.addEventListener("mouseleave", () => {
          wrFadeUpOut(dropdownMenu);
          dropdownToggle.classList.remove("active");
        });
      });
      dropdownToggle.addEventListener("click", () => {
        if (dropdownMenu.classList.contains("active")) {
          wrFadeUpOut(dropdownMenu);
          dropdownToggle.classList.remove("active");
        } else {
          wrFadeDownIn(dropdownMenu);
          dropdownToggle.classList.add("active");
        }
      });
    });
  }

  /**
   * Cookies
   */
  const cookies = document.getElementById("cookies");
  if (cookies) {
    let cookiesAccept = document.getElementById("cookiesAccept");
    let currentCookies = document.cookie;

    if (!currentCookies.includes("cookiesAccept=true")) {
      cookies.style.display = "block";
      cookiesAccept.addEventListener("click", () => {
        var cookieDate = new Date();
        cookieDate.setMonth(cookieDate.getMonth() + 12);

        document.cookie =
          "cookiesAccept=true" + ";expires=" + cookieDate + ";path=/";
        gsap.to(cookies, { x: -1000, autoAlpha: 0 });
      });
    }
  }

  /**
   * Swiper
   */
  // let swiperWrapper = document.querySelectorAll(".swiper-wrapper");
  // if (swiperWrapper.length >= 1) {
  //   swiperWrapper.forEach((i) => {
  //     i.nextElementSibling.classList.contains("swiper-pagination")
  //       ? i.classList.add("mb-6")
  //       : null;
  //   });
  // }

  new Swiper(
    ".case-study-gallery.swiper-container, .news-feed.swiper-container",
    {
      loop: false,
      grabCursor: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    }
  );

  /**
   * Fancybox
   */
  // protect images from being downloaded
  $("[data-fancybox]").fancybox({
    protect: true
  });
}); // end document ready
